import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import InsiderCard from './InsiderCard.comp';

const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        fontWeight: 500,
    },
    emptyState: {
        textAlign: 'center',
        padding: theme.spacing(3),
        color: theme.palette.text.secondary,
    }
}));

function InsidersList({ insiders, onDataUpdate, showDQW = false }) {
    const classes = useStyles();

    if (!insiders || insiders.length === 0) {
        return (
            <div className={classes.emptyState}>
                <Typography variant="body1">No insider data available</Typography>
            </div>
        );
    }

    // Sort insiders by priority: those with more pending/under-review bills first
    const sortedInsiders = [...insiders].sort((a, b) => {
        const getPriorityCount = (insider) => {
            if (!insider.billing_records) return 0;
            const pendingCount = insider.billing_records.filter(record => record.status === 1).length;
            const underReviewCount = insider.billing_records.filter(record => record.status === 3).length;
            return pendingCount + underReviewCount;
        };

        const priorityA = getPriorityCount(a);
        const priorityB = getPriorityCount(b);

        // Sort in descending order (higher priority first)
        if (priorityA !== priorityB) {
            return priorityB - priorityA;
        }

        // If same priority, sort by display name alphabetically
        const nameA = a.insider_profile?.display_name || 
                     `${a.insider_profile?.first_name || ''} ${a.insider_profile?.last_name || ''}`.trim();
        const nameB = b.insider_profile?.display_name || 
                     `${b.insider_profile?.first_name || ''} ${b.insider_profile?.last_name || ''}`.trim();
        
        return nameA.localeCompare(nameB);
    });

    return (
        <div>
            <Typography variant="h6" className={classes.sectionTitle}>
                Insider Details ({insiders.length})
            </Typography>
            {sortedInsiders.map((insider, index) => (
                <InsiderCard 
                    key={insider.dq_insider_id || index} 
                    insider={insider} 
                    onDataUpdate={onDataUpdate}
                    showDQW={showDQW}
                />
            ))}
        </div>
    );
}

export default InsidersList;
